<h1 class="text-center border-bottom pb-3">Kramp Price Export control</h1>

<div
  *ngIf="showUnauthorizedWarning"
  class="alert alert-warning mt-3"
>
  <h2 class="h5 mb-2">Alleen voor Product Factory</h2>
  <p class="mb-0">Raak deze instellingen niet aan tenzij je onderdeel bent van het Product Factory-team (AWS-PF).</p>
</div>

<ng-container *ngIf="!showUnauthorizedWarning">
  <div
    class="row justify-content-center"
    [ngClass]="{ 'd-none': feedbackSettings.show }"
  >
    <div class="col-12 col-lg-9 col-xl-7 p-3">
      <div class="card shadow-sm">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div>
            <h5 class="mb-1">Kramp Price Export control</h5>
            <p class="mb-0 text-muted">Beheer de exportstatus voor Kramp pricing.</p>
          </div>
          <button
            class="btn btn-sm btn-outline-secondary"
            type="button"
            (click)="loadExportState()"
            [disabled]="isExportStateLoading || isExportStateUpdating"
          >
            <span
              *ngIf="isExportStateLoading"
              class="spinner-border spinner-border-sm me-2"
            ></span>
            Vernieuwen
          </button>
        </div>
        <div class="card-body">
          <ng-container *ngIf="currentExportState && !isExportStateLoading; else exportStateLoading">
            <div class="row g-3 mb-4">
              <div class="col-md-4">
                <p class="mb-1"><strong>Staat</strong></p>
                <span [ngClass]="getExportStateBadgeClass(currentExportState.state)">
                  {{ getExportStateDisplayName(currentExportState.state) }}
                </span>
              </div>
              <div class="col-md-4">
                <p class="mb-1"><strong>Bijgewerkt op</strong></p>
                <p class="mb-0">
                  {{
                    currentExportState.updatedAt ? (currentExportState.updatedAt | utcDate: 'dd-MM-yyyy HH:mm') : '-'
                  }}
                </p>
              </div>
              <div class="col-md-4">
                <p class="mb-1"><strong>Bijgewerkt door</strong></p>
                <p class="mb-0">{{ currentExportState.updatedBy || '-geen-' }}</p>
              </div>
            </div>

            <div class="mb-4">
              <p class="mb-1"><strong>Huidige opmerking</strong></p>
              <p class="mb-0">{{ currentExportState.comment === '' ? '-geen-' : currentExportState.comment }}</p>
            </div>

            <div class="border-top pt-4">
              <div class="row g-3">
                <div class="col-md-5">
                  <label
                    class="form-label"
                    for="exportStateSelect"
                    >Nieuwe staat</label
                  >
                  <select
                    class="form-select"
                    id="exportStateSelect"
                    [(ngModel)]="selectedExportState"
                    name="exportStateSelect"
                    [disabled]="isExportStateUpdating"
                  >
                    <option
                      value=""
                      disabled
                      hidden
                    >
                      Selecteer een staat
                    </option>
                    <option
                      *ngFor="let state of availableExportStates"
                      [value]="state"
                      [disabled]="
                        state === currentExportState.state || state === krampPriceExportStateValues.MS_RUNNING_EXPORT
                      "
                    >
                      {{ getExportStateDisplayName(state) }}
                    </option>
                  </select>
                </div>

                <div class="col-md-7">
                  <label
                    class="form-label"
                    for="exportCommentInput"
                    >Opmerking</label
                  >
                  <textarea
                    class="form-control"
                    id="exportCommentInput"
                    rows="3"
                    [(ngModel)]="exportComment"
                    name="exportComment"
                    placeholder="Voeg een opmerking toe over deze exportstaatswijziging..."
                    [disabled]="isExportStateUpdating"
                  ></textarea>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  [disabled]="!canUpdateExportState()"
                  (click)="updateExportState()"
                >
                  <span
                    *ngIf="isExportStateUpdating"
                    class="spinner-border spinner-border-sm me-2"
                  ></span>
                  {{ isExportStateUpdating ? 'Bijwerken...' : 'Exportstaat bijwerken' }}
                </button>
              </div>
            </div>
          </ng-container>
          <ng-template #exportStateLoading>
            <div class="d-flex justify-content-center py-4">
              <span class="spinner-border text-secondary"></span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div
  class="d-flex justify-content-center feedback_box"
  [ngClass]="{
    'd-none': !feedbackSettings.show,
  }"
>
  <app-feedback
    [(settings)]="feedbackSettings"
    (update)="returnHome()"
  ></app-feedback>
</div>

<div [ngClass]="{ 'd-none': !isLoading }">
  <app-loading-gears></app-loading-gears>
</div>
